// F1 2026 Kalender (Stand: aktueller F1-Kalender)
// Nur Streckenname + Land-Code + Kürzel
export const F1_2026_TRACKS = [
  { track: "Melbourne",     country_code: "AU", short_code: "MEL" },
  { track: "Shanghai",      country_code: "CN", short_code: "SHA" },
  { track: "Suzuka",        country_code: "JP", short_code: "SUZ" },
  { track: "Sakhir",        country_code: "BH", short_code: "BHR" },
  { track: "Jeddah",        country_code: "SA", short_code: "JED" },
  { track: "Miami",         country_code: "US", short_code: "MIA" },
  { track: "Imola",         country_code: "IT", short_code: "IMO" },
  { track: "Monaco",        country_code: "MC", short_code: "MON" },
  { track: "Montréal",      country_code: "CA", short_code: "MTL" },
  { track: "Madrid",        country_code: "ES", short_code: "MAD" },
  { track: "Barcelona",     country_code: "ES", short_code: "BCN" },
  { track: "Spielberg",     country_code: "AT", short_code: "RBR" },
  { track: "Silverstone",   country_code: "GB", short_code: "SIL" },
  { track: "Budapest",      country_code: "HU", short_code: "HUN" },
  { track: "Spa",           country_code: "BE", short_code: "SPA" },
  { track: "Zandvoort",     country_code: "NL", short_code: "ZAN" },
  { track: "Monza",         country_code: "IT", short_code: "MNZ" },
  { track: "Baku",          country_code: "AZ", short_code: "BAK" },
  { track: "Singapur",      country_code: "SG", short_code: "SIN" },
  { track: "Austin",        country_code: "US", short_code: "COT" },
  { track: "Mexico-Stadt",  country_code: "MX", short_code: "MEX" },
  { track: "São Paulo",     country_code: "BR", short_code: "INT" },
  { track: "Las Vegas",     country_code: "US", short_code: "LVS" },
  { track: "Lusail",        country_code: "QA", short_code: "LSL" },
  { track: "Abu Dhabi",     country_code: "AE", short_code: "YAS" },
];
